import { render } from "./fb_sub_table2.vue?vue&type=template&id=7951756e&scoped=true"
import script from "./fb_sub_table2.vue?vue&type=script&lang=js"
export * from "./fb_sub_table2.vue?vue&type=script&lang=js"

import "./fb_sub_table2.vue?vue&type=style&index=0&id=7951756e&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\data_dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7951756e"]])

export default __exports__